import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AutocompleteSpeechService {

  announce(msg: string) {
    let el = document.getElementById('ui-live-region');

    if (!el) {
      el = document.createElement('div');
      el.id = 'ui-live-region';
      el.classList.add('ui-helper-hidden-accessible');
      el.setAttribute('aria-live', 'assertive');
      document.body.appendChild(el);
    }

    el.textContent = msg;
  }

}
